export default __webpack_public_path__ + "static/media/xandr-logo.6b9eeebf.svg";